/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import NoDataResult from 'DesignSystem/Images/NoDataResult/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/PerformTrace/Content/Empty"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-4PwO0': isBefore ? 0 : 1,'--ty-2-4PwO0': isBefore ? "8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<NoDataResult
  viewPath={`${viewPath}/NoDataResult`}
 width={150}
 height="auto"
/>
<span
  data-testid="Empty.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
No Analysis Types found
</span>
</div>
{children}
</React.Fragment>)
}